import React, { Component } from 'react'
import { connect } from 'react-redux'
import Redirect from './Redirect'

import { callLogin } from '../actions'

import Logo from '../assets/logo.svg'
import Loader from './Loader'
import Map from './Map'

const initialState = {
  email: '',
  password: ''
}

class Login extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  tryLogin(event) {
    if (event.key === 'Enter') {
      this.login()
    }
  }

  login() {
    let valid = true
    if (this.state.email === '') {
      valid = false
    }
    if (this.state.password === '') {
      valid = false
    }
    if (valid) {
      this.props.callLogin({
        email: this.state.email,
        password: this.state.password
      })
    }
  }

  render() {
    const { loading, error, valid } = this.props.auth
    return (
      <div>
        <Map css='full' />
        <div className='login-container'>
          <img src={Logo} alt='Anomaleet' />
          <label>
            <span>Email</span>
            <input
              type='email'
              placeholder='Email'
              onChange={(event) => this.setState({ email: event.target.value })}
              onKeyPress={(event) => this.tryLogin(event)}
              value={this.state.email}
            />
          </label>
          <label>
            <span>Password</span>
            <input
              type='password'
              placeholder='Password'
              onChange={(event) =>
                this.setState({ password: event.target.value })
              }
              onKeyPress={(event) => this.tryLogin(event)}
              value={this.state.password}
            />
          </label>
          <button className='lnk-login' onClick={() => this.login()}>
            Accedi
          </button>
          {loading && <Loader />}
          {error !== null && (
            <div className='err-response'>Dati errati, riprovare</div>
          )}
          {valid && <Redirect to='/dashboard' />}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { callLogin })(Login)
